export default {
      id: "question-in-circle-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.4f7c228b.svg#question-in-circle",
      toString: function () {
        return this.url;
      }
    }